import { FC, ReactNode } from 'react';
import { ContentResponse } from '../../types/shared';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import styles from './PageInfo.module.css';
import PublishDate from '../PublishDate/PublishDate';

type PageInfoProps = {
  contentResponse: ContentResponse;
  variant?: 'both' | 'breadcrumbs' | 'publish';
};

const PageInfo: FC<PageInfoProps> = ({ contentResponse, variant }): ReactNode => {
  return (
    <div className={styles.container}>
      {(variant === 'both' || variant === 'breadcrumbs') && <Breadcrumbs contentResponse={contentResponse}></Breadcrumbs>}

      {(variant === 'both' || variant === 'publish') && (
        <div className={styles.right}>
          <PublishDate content={contentResponse}></PublishDate>
        </div>
      )}
    </div>
  );
};

export default PageInfo;
